import { useEffect } from 'react';
import { useToast } from '../ToastMessage/Toast';

const AlertDialog = ({ isOpen, title, message, onClose, onCancel }) => {
  const showToast = useToast();

  useEffect(() => {
    if (!isOpen) return undefined;

    const text = message || title;
    if (text) {
      showToast(text);
    }

    if (onCancel) {
      onCancel();
    } else if (onClose) {
      onClose();
    }
  }, [isOpen, title, message, onClose, onCancel, showToast]);

  return null;
};

export default AlertDialog;
